<script setup lang="ts">
import { marketForex } from "~/helpers/live-market";
import { normalizeDiscoveryItems } from "~/helpers/markets";

const topFourMarketForex = marketForex.slice(0, 4);

const { data: tickData, status } = useCustomFetch("/api/mt5/ticks", {
  method: "POST",
  body: {
    symbols: topFourMarketForex.map((item) => item.mt5Symbol),
  },
});

const discoverItems = computed(() =>
  normalizeDiscoveryItems(topFourMarketForex, tickData.value?.tick_data),
);

const { data } = useCustomFetch("/api/strapi/markets", {
  query: { "filters[market][$eq]": "forex" },
});

const market = computed(() => data.value?.[0]?.attributes?.content);
const faqs = computed(() => data.value?.[0]?.attributes?.faqs);

// useSeoMeta(getSeoObject(market?.value?.seo));
</script>

<template>
  <section v-if="market" id="maincontentblock">
    <SeoMeta v-if="market?.seo" v-bind="market?.seo" />
    <FullScreenLoader v-if="status === 'pending'" />
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <h2 class="title">{{ market.title }}</h2>
          <p class="titledesci" style="white-space: pre-line">
            {{ market.description }}
          </p>

          <NuxtLinkLocale class="buttons tradeit" href="/register">{{
            market.tradeButtonText
          }}</NuxtLinkLocale>
        </div>
      </div>

      <MarketsDiscover
        market="Forex"
        :title="market.discoverTitle"
        :items="discoverItems"
      />

      <div class="row">
        <div class="col-md-12">
          <h2 class="title">{{ market?.trendingStocksTitle }}</h2>
          <p
            class="titledesci popularStocks"
            v-html="
              $mdRenderer.renderInline(market?.trendingStocksSubtitle || '')
            "
          ></p>
        </div>
      </div>

      <TrendingForex />

      <div class="row tradecfds modififi">
        <div class="candle" data-aos="zoom-in-up" data-aos-delay="200"></div>
        <div class="col-md-12"></div>

        <div class="my-animated-box animate-this">
          <div class="my-animated-box__children animate-this"></div>
        </div>
        <div class="my-animated-box animate-this">
          <div class="my-animated-box__children animate-this seccond"></div>
        </div>
      </div>

      <div class="wrapperblock">
        <div class="row">
          <div class="col-md-7 forex-col-md-7">
            <h2>{{ market.explore.innerTitle }}</h2>
            <div
              v-html="$mdRenderer.render(market.explore.innerDescription)"
            ></div>
          </div>

          <div class="col-md-5 forex-col-md-5">
            <img
              :src="$getStrapiImageSrc(market.explore.image)"
              class="stockimg forex-stockimgs"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12 col-lg-6">
            <div id="innerv2-zero" class="wrapperblock inner">
              <h2>{{ market.explore.benefitsTitle }}</h2>
              <div
                v-html="$mdRenderer.render(market.explore.benefitsText)"
              ></div>
            </div>
          </div>
          <div class="col-xs-12 col-lg-6">
            <div id="innerv2-one" class="wrapperblock inner">
              <h2>{{ market.explore.howTitle }}</h2>
              <div v-html="$mdRenderer.render(market.explore.howText)"></div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <NuxtLinkLocale href="/register" class="buttons">{{
              market.explore.buttonText
            }}</NuxtLinkLocale>
          </div>
        </div>
      </div>

      <MarketsWhy :title="market.whyTitle" :items="market.whyItems" />
    </div>
  </section>

  <JoinCta />

  <FaqItems :items="faqs" />
</template>
